
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5ca1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5ca1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1fxkH", function(module, exports) {

$parcel$export(module.exports, "WidjetInput", () => $51e792c9e4ac54aa$export$b4e4193e9ab69437);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $bs2PT = parcelRequire("bs2PT");
function $51e792c9e4ac54aa$export$b4e4193e9ab69437({ icon: icon, label: label, inputProps: inputProps, onMouseDown: onMouseDown, id: id, className: className = "", insideModule: insideModule = false, disabled: disabled = false, isInWidjet: isInWidjet = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).wrapper, className, insideModule ? (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).insideModule : "", disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).disabled : "", isInWidjet ? (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).inWidjet : ""),
        onMouseDown: onMouseDown,
        id: id,
        children: [
            icon && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).group,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).label,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).input, inputProps.className),
                        children: inputProps.value
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("bs2PT", function(module, exports) {

$parcel$export(module.exports, "disabled", () => $85648266e47c6144$export$683472f6198a076e, (v) => $85648266e47c6144$export$683472f6198a076e = v);
$parcel$export(module.exports, "group", () => $85648266e47c6144$export$e5e25fbcc1f7affe, (v) => $85648266e47c6144$export$e5e25fbcc1f7affe = v);
$parcel$export(module.exports, "icon", () => $85648266e47c6144$export$1ca1ec8b29a4ce27, (v) => $85648266e47c6144$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "inWidjet", () => $85648266e47c6144$export$b10ae9cb4281886d, (v) => $85648266e47c6144$export$b10ae9cb4281886d = v);
$parcel$export(module.exports, "input", () => $85648266e47c6144$export$b7e3ae3d7c15e42e, (v) => $85648266e47c6144$export$b7e3ae3d7c15e42e = v);
$parcel$export(module.exports, "insideModule", () => $85648266e47c6144$export$4587c03c9e282da2, (v) => $85648266e47c6144$export$4587c03c9e282da2 = v);
$parcel$export(module.exports, "label", () => $85648266e47c6144$export$1237798dc640739a, (v) => $85648266e47c6144$export$1237798dc640739a = v);
$parcel$export(module.exports, "loader", () => $85648266e47c6144$export$f4c5de44377d2946, (v) => $85648266e47c6144$export$f4c5de44377d2946 = v);
$parcel$export(module.exports, "spin", () => $85648266e47c6144$export$c82e186cf428d56d, (v) => $85648266e47c6144$export$c82e186cf428d56d = v);
$parcel$export(module.exports, "wrapper", () => $85648266e47c6144$export$cc74dcc53cfce4eb, (v) => $85648266e47c6144$export$cc74dcc53cfce4eb = v);
var $85648266e47c6144$export$683472f6198a076e;
var $85648266e47c6144$export$e5e25fbcc1f7affe;
var $85648266e47c6144$export$1ca1ec8b29a4ce27;
var $85648266e47c6144$export$b10ae9cb4281886d;
var $85648266e47c6144$export$b7e3ae3d7c15e42e;
var $85648266e47c6144$export$4587c03c9e282da2;
var $85648266e47c6144$export$1237798dc640739a;
var $85648266e47c6144$export$f4c5de44377d2946;
var $85648266e47c6144$export$c82e186cf428d56d;
var $85648266e47c6144$export$cc74dcc53cfce4eb;
$85648266e47c6144$export$683472f6198a076e = `BG7B0W_disabled`;
$85648266e47c6144$export$e5e25fbcc1f7affe = `BG7B0W_group`;
$85648266e47c6144$export$1ca1ec8b29a4ce27 = `BG7B0W_icon`;
$85648266e47c6144$export$b10ae9cb4281886d = `BG7B0W_inWidjet`;
$85648266e47c6144$export$b7e3ae3d7c15e42e = `BG7B0W_input`;
$85648266e47c6144$export$4587c03c9e282da2 = `BG7B0W_insideModule`;
$85648266e47c6144$export$1237798dc640739a = `BG7B0W_label`;
$85648266e47c6144$export$f4c5de44377d2946 = `BG7B0W_loader`;
$85648266e47c6144$export$c82e186cf428d56d = `BG7B0W_spin`;
$85648266e47c6144$export$c82e186cf428d56d;
$85648266e47c6144$export$cc74dcc53cfce4eb = `BG7B0W_wrapper`;

});


parcelRegister("cEBWW", function(module, exports) {

$parcel$export(module.exports, "WidjetContext", () => $9366a87a96d4dc4c$export$c189e89d0260ae4a);

var $acw62 = parcelRequire("acw62");
const $9366a87a96d4dc4c$export$c189e89d0260ae4a = /*#__PURE__*/ (0, $acw62.createContext)();

});

parcelRegister("9aJuM", function(module, exports) {

$parcel$export(module.exports, "getModuleIframe", () => $6ad856b371c80c08$export$6a7b0335c5fca543);

var $acw62 = parcelRequire("acw62");
function $6ad856b371c80c08$export$6a7b0335c5fca543(src, dateFrom, dateTo, rooms, timeSettings) {
    const url = new URL(src);
    url.searchParams.append("dateFrom", dateFrom);
    url.searchParams.append("dateTo", dateTo);
    url.searchParams.append("rooms", JSON.stringify(rooms));
    url.searchParams.append("timeSettings", JSON.stringify(timeSettings));
    const module = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("iframe", {
        src: url,
        className: "lv-booking-module",
        id: "lv-booking-module"
    });
    return module;
}

});

parcelRegister("cE3WW", function(module, exports) {

$parcel$export(module.exports, "reviveObject", () => $934c48c7f7d7781a$export$be25b1c6e1698b21);
function $934c48c7f7d7781a$export$be25b1c6e1698b21(object) {
    for (let [key, value] of Object.entries(object)){
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value)) object[key] = new Date(value);
        if (typeof value === "object" && value !== null) object[key] = $934c48c7f7d7781a$export$be25b1c6e1698b21(value);
    }
    return object;
}

});

parcelRegister("jRUmS", function(module, exports) {

$parcel$export(module.exports, "useIsMount", () => $e76eb11489810a12$export$75fb93ecafaf38d5);

var $acw62 = parcelRequire("acw62");
const $e76eb11489810a12$export$75fb93ecafaf38d5 = ()=>{
    const isMountRef = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        isMountRef.current = false;
    }, []);
    return isMountRef.current;
};

});


var $ayMG0 = parcelRequire("ayMG0");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $3f08f3da266a4fc5$exports = {};

$parcel$export($3f08f3da266a4fc5$exports, "active", () => $3f08f3da266a4fc5$export$89da14300d534261, (v) => $3f08f3da266a4fc5$export$89da14300d534261 = v);
$parcel$export($3f08f3da266a4fc5$exports, "calendarCard", () => $3f08f3da266a4fc5$export$c57e90396a5fdda5, (v) => $3f08f3da266a4fc5$export$c57e90396a5fdda5 = v);
$parcel$export($3f08f3da266a4fc5$exports, "calendarContainer", () => $3f08f3da266a4fc5$export$761099f155521a60, (v) => $3f08f3da266a4fc5$export$761099f155521a60 = v);
$parcel$export($3f08f3da266a4fc5$exports, "calendarWrapper", () => $3f08f3da266a4fc5$export$c30e453142468ef3, (v) => $3f08f3da266a4fc5$export$c30e453142468ef3 = v);
$parcel$export($3f08f3da266a4fc5$exports, "contentShow", () => $3f08f3da266a4fc5$export$80b267e3ef38fe4a, (v) => $3f08f3da266a4fc5$export$80b267e3ef38fe4a = v);
$parcel$export($3f08f3da266a4fc5$exports, "dialogContent", () => $3f08f3da266a4fc5$export$1a09c8e9a482a512, (v) => $3f08f3da266a4fc5$export$1a09c8e9a482a512 = v);
$parcel$export($3f08f3da266a4fc5$exports, "dialogOverlay", () => $3f08f3da266a4fc5$export$fd1af5f6d2c0dae1, (v) => $3f08f3da266a4fc5$export$fd1af5f6d2c0dae1 = v);
$parcel$export($3f08f3da266a4fc5$exports, "errorForm", () => $3f08f3da266a4fc5$export$7aec1c0a952f8449, (v) => $3f08f3da266a4fc5$export$7aec1c0a952f8449 = v);
$parcel$export($3f08f3da266a4fc5$exports, "errorMessage", () => $3f08f3da266a4fc5$export$493b5823483d2c4e, (v) => $3f08f3da266a4fc5$export$493b5823483d2c4e = v);
$parcel$export($3f08f3da266a4fc5$exports, "errorMessageDescription", () => $3f08f3da266a4fc5$export$4b66c84692c39e67, (v) => $3f08f3da266a4fc5$export$4b66c84692c39e67 = v);
$parcel$export($3f08f3da266a4fc5$exports, "errorMessageTitle", () => $3f08f3da266a4fc5$export$8b9bf0a5c2438d10, (v) => $3f08f3da266a4fc5$export$8b9bf0a5c2438d10 = v);
$parcel$export($3f08f3da266a4fc5$exports, "fakeWidjet", () => $3f08f3da266a4fc5$export$d026c899249ef7ec, (v) => $3f08f3da266a4fc5$export$d026c899249ef7ec = v);
$parcel$export($3f08f3da266a4fc5$exports, "form", () => $3f08f3da266a4fc5$export$6210fa4921d2a466, (v) => $3f08f3da266a4fc5$export$6210fa4921d2a466 = v);
$parcel$export($3f08f3da266a4fc5$exports, "infoText", () => $3f08f3da266a4fc5$export$fda920bf43776f02, (v) => $3f08f3da266a4fc5$export$fda920bf43776f02 = v);
$parcel$export($3f08f3da266a4fc5$exports, "overlayShow", () => $3f08f3da266a4fc5$export$31832b2516c6041f, (v) => $3f08f3da266a4fc5$export$31832b2516c6041f = v);
$parcel$export($3f08f3da266a4fc5$exports, "submit", () => $3f08f3da266a4fc5$export$853c27de4ce0f746, (v) => $3f08f3da266a4fc5$export$853c27de4ce0f746 = v);
$parcel$export($3f08f3da266a4fc5$exports, "widjetInputFrom", () => $3f08f3da266a4fc5$export$9a79a55c47b78d74, (v) => $3f08f3da266a4fc5$export$9a79a55c47b78d74 = v);
$parcel$export($3f08f3da266a4fc5$exports, "widjetInputRooms", () => $3f08f3da266a4fc5$export$3e34a0fbc08aa379, (v) => $3f08f3da266a4fc5$export$3e34a0fbc08aa379 = v);
$parcel$export($3f08f3da266a4fc5$exports, "widjetInputTo", () => $3f08f3da266a4fc5$export$7e48fc659f0aa618, (v) => $3f08f3da266a4fc5$export$7e48fc659f0aa618 = v);
$parcel$export($3f08f3da266a4fc5$exports, "wrapper", () => $3f08f3da266a4fc5$export$cc74dcc53cfce4eb, (v) => $3f08f3da266a4fc5$export$cc74dcc53cfce4eb = v);
var $3f08f3da266a4fc5$export$89da14300d534261;
var $3f08f3da266a4fc5$export$c57e90396a5fdda5;
var $3f08f3da266a4fc5$export$761099f155521a60;
var $3f08f3da266a4fc5$export$c30e453142468ef3;
var $3f08f3da266a4fc5$export$80b267e3ef38fe4a;
var $3f08f3da266a4fc5$export$1a09c8e9a482a512;
var $3f08f3da266a4fc5$export$fd1af5f6d2c0dae1;
var $3f08f3da266a4fc5$export$7aec1c0a952f8449;
var $3f08f3da266a4fc5$export$493b5823483d2c4e;
var $3f08f3da266a4fc5$export$4b66c84692c39e67;
var $3f08f3da266a4fc5$export$8b9bf0a5c2438d10;
var $3f08f3da266a4fc5$export$d026c899249ef7ec;
var $3f08f3da266a4fc5$export$6210fa4921d2a466;
var $3f08f3da266a4fc5$export$fda920bf43776f02;
var $3f08f3da266a4fc5$export$31832b2516c6041f;
var $3f08f3da266a4fc5$export$853c27de4ce0f746;
var $3f08f3da266a4fc5$export$9a79a55c47b78d74;
var $3f08f3da266a4fc5$export$3e34a0fbc08aa379;
var $3f08f3da266a4fc5$export$7e48fc659f0aa618;
var $3f08f3da266a4fc5$export$cc74dcc53cfce4eb;
$3f08f3da266a4fc5$export$89da14300d534261 = `Jyl0gq_active`;
$3f08f3da266a4fc5$export$c57e90396a5fdda5 = `Jyl0gq_calendarCard`;
$3f08f3da266a4fc5$export$761099f155521a60 = `Jyl0gq_calendarContainer`;
$3f08f3da266a4fc5$export$c30e453142468ef3 = `Jyl0gq_calendarWrapper`;
$3f08f3da266a4fc5$export$80b267e3ef38fe4a = `Jyl0gq_contentShow`;
$3f08f3da266a4fc5$export$80b267e3ef38fe4a;
$3f08f3da266a4fc5$export$1a09c8e9a482a512 = `Jyl0gq_dialogContent`;
$3f08f3da266a4fc5$export$fd1af5f6d2c0dae1 = `Jyl0gq_dialogOverlay`;
$3f08f3da266a4fc5$export$7aec1c0a952f8449 = `Jyl0gq_errorForm`;
$3f08f3da266a4fc5$export$493b5823483d2c4e = `Jyl0gq_errorMessage`;
$3f08f3da266a4fc5$export$4b66c84692c39e67 = `Jyl0gq_errorMessageDescription`;
$3f08f3da266a4fc5$export$8b9bf0a5c2438d10 = `Jyl0gq_errorMessageTitle`;
$3f08f3da266a4fc5$export$d026c899249ef7ec = `Jyl0gq_fakeWidjet`;
$3f08f3da266a4fc5$export$6210fa4921d2a466 = `Jyl0gq_form`;
$3f08f3da266a4fc5$export$fda920bf43776f02 = `Jyl0gq_infoText`;
$3f08f3da266a4fc5$export$31832b2516c6041f = `Jyl0gq_overlayShow`;
$3f08f3da266a4fc5$export$31832b2516c6041f;
$3f08f3da266a4fc5$export$853c27de4ce0f746 = `Jyl0gq_submit`;
$3f08f3da266a4fc5$export$9a79a55c47b78d74 = `Jyl0gq_widjetInputFrom`;
$3f08f3da266a4fc5$export$3e34a0fbc08aa379 = `Jyl0gq_widjetInputRooms`;
$3f08f3da266a4fc5$export$7e48fc659f0aa618 = `Jyl0gq_widjetInputTo`;
$3f08f3da266a4fc5$export$cc74dcc53cfce4eb = `Jyl0gq_wrapper`;



var $1fxkH = parcelRequire("1fxkH");

var $avF3t = parcelRequire("avF3t");

var $8g1PZ = parcelRequire("8g1PZ");

var $cEBWW = parcelRequire("cEBWW");

var $6IhJz = parcelRequire("6IhJz");
var $cFZfS = parcelRequire("cFZfS");

var $cUaZe = parcelRequire("cUaZe");
parcelRequire("9aJuM");

var $g1OEl = parcelRequire("g1OEl");

var $hjbdS = parcelRequire("hjbdS");

var $7siT5 = parcelRequire("7siT5");

var $cE3WW = parcelRequire("cE3WW");

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $bs2PT = parcelRequire("bs2PT");

var $drrc6 = parcelRequire("drrc6");
function $72f3290f64a4d5f1$export$b37f2c7dc12a79b6({ icon: icon, className: className = "", label: label }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).wrapper, className),
        children: [
            icon && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).group,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).label,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bs2PT))).loader,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drrc6.SpinnerIcon), {}),
                            " \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
                        ]
                    })
                ]
            })
        ]
    });
}


parcelRequire("jRUmS");
function $8531facd38432db1$export$511301e5919f9ef5() {
    const store = (0, $acw62.useRef)((0, $7siT5.useWidjetStore)()).current;
    const isFailed = (0, $cUaZe.useStore)(store, (state)=>state.isFailed);
    const loading = (0, $cUaZe.useStore)(store, (state)=>state.loading);
    // const mode = useStore(store, state => state.mode);
    (0, $acw62.useEffect)(()=>{
        function messageHandler(event) {
            if (event.origin !== "https://fongrad.ru" && event.origin !== "https://www.fongrad.ru") return;
            if (event.data.isBookingModuleAction) switch(event.data.action){
                case "updateStore":
                    store.setState((0, $cE3WW.reviveObject)(event.data.data));
                    break;
                default:
                    return;
            }
        }
        window.addEventListener("message", messageHandler);
        return ()=>{
            window.removeEventListener("message", messageHandler);
        };
    }, [
        store
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $hjbdS.postMessageIntoApp)({
            action: "initFromWidjet"
        });
    }, []);
    // useWidjetStoreController(store, [mode])
    // const setDateFrom = useStore(store, state => state.setDateFrom);
    // const setDateTo = useStore(store, state => state.setDateTo);
    // const setRooms = useStore(store, state => state.setRooms);
    // useEffect(() => {
    //     function popstateHandler(e) {
    //         if (!e.state?.lv_module_open) {
    //             setModuleOpen(false)
    //         }
    //     }
    //     window.addEventListener('popstate', popstateHandler);
    //     return () => {
    //         window.removeEventListener('popstate', popstateHandler);
    //     }
    // }, [moduleOpen, setModuleOpen]);
    // useEffect(() => {
    //     function messageHandler(e) {
    //         if (e.origin === process.env.SITE_ORIGIN) {
    //             if (e.data.dateFrom && e.data.dateTo && e.data.rooms) {
    //                 setDateFrom(new Date(e.data.dateFrom))
    //                 setDateTo(new Date(e.data.dateTo))
    //                 setRooms(e.data.rooms);
    //             }
    //         }
    //     }
    //     window.addEventListener("message", messageHandler);
    //     return () => {
    //         window.removeEventListener("message", messageHandler);
    //     }
    // }, [setDateFrom, setDateTo, setRooms])
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cEBWW.WidjetContext).Provider, {
        value: store,
        children: [
            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($8531facd38432db1$export$8113675804249431, {}) : "",
            !loading && !isFailed ? /*#__PURE__*/ (0, $ayMG0.jsx)($8531facd38432db1$export$f0cb755d270fc817, {}) : ""
        ]
    });
}
// function useWidjetStoreController(store, params) {
//     const isMount = useIsMount();
//     useEffect(() => {
//         if (!isMount) {
//             postMessageIntoApp({ action: "updateStoreFromWidjet", data: JSON.parse(JSON.stringify({ ...store.getState() })) })
//         }
//     }, [store, ...params, isMount])
// }
// Поле "Гости"
function $8531facd38432db1$var$TextFieldRooms({ rooms: rooms, onMouseDown: onMouseDown, active: active }) {
    const adultsCount = rooms.reduce((sum, current)=>+sum + +current.adults, 0);
    const childsCount = rooms.reduce((sum, current)=>+sum + +current.childrens.length, 0);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fxkH.WidjetInput), {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $avF3t.PersonIcon), {}),
        label: "\u0413\u043E\u0441\u0442\u0438",
        inputProps: {
            value: `${adultsCount} ${adultsCount > 1 ? "\u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0445" : "\u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0439"}, ${childsCount} ${childsCount <= 1 && childsCount !== 0 ? "\u0440\u0435\u0431\u0435\u043D\u043E\u043A" : "\u0434\u0435\u0442\u0435\u0439"}`,
            placeholder: "\u0413\u043E\u0441\u0442\u0438",
            readOnly: true,
            type: "text"
        },
        onMouseDown: onMouseDown,
        id: "booking-rooms-field",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).widjetInputRooms, active ? (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).active : ""),
        isInWidjet: true
    });
}
// Поле "Дата Выезда"
function $8531facd38432db1$var$TextFieldTo({ value: value, onMouseDown: onMouseDown, active: active }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fxkH.WidjetInput), {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $avF3t.CalendarIcon), {}),
        label: "\u0412\u044B\u0435\u0437\u0434",
        inputProps: {
            value: value,
            placeholder: "\u0412\u044B\u0435\u0437\u0434",
            readOnly: true,
            type: "text"
        },
        onMouseDown: onMouseDown,
        id: "booking-to-field",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).widjetInputTo, active ? (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).active : ""),
        isInWidjet: true
    });
}
// Поле "Дата Заезда"
function $8531facd38432db1$var$TextFieldFrom({ value: value, onMouseDown: onMouseDown, active: active }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fxkH.WidjetInput), {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $avF3t.CalendarIcon), {}),
        label: "\u0417\u0430\u0435\u0437\u0434",
        inputProps: {
            value: value,
            placeholder: "\u0417\u0430\u0435\u0437\u0434",
            readOnly: true,
            type: "text"
        },
        onMouseDown: onMouseDown,
        id: "booking-from-field",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).widjetInputFrom, active ? (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).active : ""),
        isInWidjet: true
    });
}
function $8531facd38432db1$export$8113675804249431({ setIsModuleOpen: setIsModuleOpen, setModuleIframe: setModuleIframe, setIsFailed: setIsFailed }) {
    const store = (0, $acw62.useContext)((0, $cEBWW.WidjetContext));
    const dateFrom = (0, $cUaZe.useStore)(store, (state)=>state.dateFrom);
    const dateTo = (0, $cUaZe.useStore)(store, (state)=>state.dateTo);
    const rooms = (0, $cUaZe.useStore)(store, (state)=>state.rooms);
    const timeSettings = (0, $cUaZe.useStore)(store, (state)=>state.timeSettings);
    const setRooms = (0, $cUaZe.useStore)(store, (state)=>state.setRooms);
    const roomsLimits = (0, $cUaZe.useStore)(store, (state)=>state.roomsLimits);
    const monthFrom = new Date(new Date(new Date().setDate(1)).setHours(0, 0, 0, 0));
    const mode = (0, $cUaZe.useStore)(store, (state)=>state.mode);
    const setMode = (0, $cUaZe.useStore)(store, (state)=>state.setMode);
    const [calendarOpen, setCalendarOpen] = (0, $acw62.useState)(false);
    const [roomsOpen, setRoomsOpen] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        function messageHandler(event) {
            if (event.data.isBookingModuleAction && (event.origin === "https://fongrad.ru" || event.origin === "https://www.fongrad.ru")) switch(event.data.action){
                case "closeCalendar":
                    (0, $hjbdS.postMessageIntoApp)({
                        action: "closeCalendar"
                    });
                    setCalendarOpen(false);
                    break;
                case "closeRooms":
                    (0, $hjbdS.postMessageIntoApp)({
                        action: "closeRooms"
                    });
                    setRoomsOpen(false);
                    break;
                default:
                    return;
            }
        }
        window.addEventListener("message", messageHandler);
        return ()=>{
            window.removeEventListener("message", messageHandler);
        };
    }, [
        store
    ]);
    // Размер экрана
    const size = (0, $g1OEl.default)();
    // Нажатие на инпут выезда
    function mouseDownToFieldHandler() {
        const dataToUpdate = {};
        dataToUpdate.range = {
            from: dateFrom,
            to: dateTo
        };
        dataToUpdate.numberOfMonths = 2;
        if (mode === "from") {
            (0, $hjbdS.postMessageIntoApp)({
                action: "openCalendar"
            });
            setCalendarOpen(true);
        } else {
            (0, $hjbdS.postMessageIntoApp)({
                action: !calendarOpen ? "openCalendar" : "closeCalendar"
            });
            setCalendarOpen(!calendarOpen);
        }
        if ((0, $cFZfS.default)(dateTo)) dataToUpdate.month = size.width > 768 ? new Date(new Date(new Date(dateTo).setDate(1)).setHours(0, 0, 0, 0)) : monthFrom;
        dataToUpdate.mode = "to";
        (0, $hjbdS.postMessageIntoApp)({
            action: "updateStoreFromWidjet",
            data: dataToUpdate
        });
        setMode("to");
    }
    // Нажатие на инпут въезда
    function mouseDownFromFiledHandler() {
        const dataToUpdate = {};
        dataToUpdate.range = {
            from: dateFrom,
            to: dateTo
        };
        dataToUpdate.numberOfMonths = 2;
        (0, $hjbdS.postMessageIntoApp)({
            action: !calendarOpen ? "openCalendar" : "closeCalendar"
        });
        setCalendarOpen(!calendarOpen);
        if ((0, $cFZfS.default)(dateFrom) && (0, $cFZfS.default)(dateTo)) dataToUpdate.month = size.width > 768 ? new Date(new Date(new Date(dateFrom).setDate(1)).setHours(0, 0, 0, 0)) : monthFrom;
        dataToUpdate.mode = "from";
        (0, $hjbdS.postMessageIntoApp)({
            action: "updateStoreFromWidjet",
            data: dataToUpdate
        });
        setMode("from");
    }
    // Проверяем форму и открываем модуль бронирования 
    function sumbitHandler(e) {
        e.preventDefault();
        function validate() {
            // Проверка на незаполненного ребенка
            if (rooms.find((item)=>item.childrens.filter((children)=>children === "").length !== 0)) {
                setRoomsOpen(true);
                (0, $hjbdS.postMessageIntoApp)({
                    action: "openRooms"
                });
                return false;
            }
            return true;
        }
        if (validate()) {
            // setModuleIframe(getModuleIframe(process.env.MODULE_ORIGIN, dateFrom, dateTo, rooms, timeSettings));
            window.history.replaceState({
                ...window.history.state,
                lv_module_open: false
            }, "", window.location.href);
            window.history.pushState({
                ...window.history.state,
                lv_module_open: true
            }, "", window.location.href);
            // setIsModuleOpen(true);
            (0, $hjbdS.postMessageIntoApp)({
                action: "openModule"
            });
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).wrapper,
        onClick: ()=>{
            (0, $hjbdS.postMessageIntoApp)({
                action: "closeCalendar"
            });
            (0, $hjbdS.postMessageIntoApp)({
                action: "closeRooms"
            });
            setCalendarOpen(false);
            setRoomsOpen(false);
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).form,
            onSubmit: sumbitHandler,
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($8531facd38432db1$var$TextFieldFrom, {
                    value: (0, $6IhJz.default)(dateFrom, "dd.MM.yyyy"),
                    onMouseDown: mouseDownFromFiledHandler,
                    active: calendarOpen && mode === "from"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($8531facd38432db1$var$TextFieldTo, {
                    value: (0, $6IhJz.default)(dateTo, "dd.MM.yyyy"),
                    onMouseDown: mouseDownToFieldHandler,
                    active: calendarOpen && mode === "to"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($8531facd38432db1$var$TextFieldRooms, {
                        rooms: rooms,
                        onMouseDown: ()=>{
                            setRoomsOpen(!roomsOpen);
                            (0, $hjbdS.postMessageIntoApp)({
                                action: !roomsOpen ? "openRooms" : "closeRooms"
                            });
                        },
                        active: roomsOpen
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    color: "dark",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).submit,
                    type: "button",
                    onClick: sumbitHandler,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $avF3t.MagnifyingGlassIcon), {}),
                        " \u041D\u0430\u0439\u0442\u0438"
                    ]
                })
            ]
        })
    });
}
function $8531facd38432db1$export$f0cb755d270fc817() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).wrapper, (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).fakeWidjet),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).form,
            onSubmit: (e)=>e.preventDefault(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72f3290f64a4d5f1$export$b37f2c7dc12a79b6), {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $avF3t.CalendarIcon), {}),
                    label: "\u0417\u0430\u0435\u0437\u0434",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).widjetInputFrom
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72f3290f64a4d5f1$export$b37f2c7dc12a79b6), {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $avF3t.CalendarIcon), {}),
                    label: "\u0412\u044B\u0435\u0437\u0434",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).widjetInputTo
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72f3290f64a4d5f1$export$b37f2c7dc12a79b6), {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $avF3t.PersonIcon), {}),
                    label: "\u0413\u043E\u0441\u0442\u0438",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).widjetInputRooms
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    color: "dark",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3f08f3da266a4fc5$exports))).submit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $avF3t.MagnifyingGlassIcon), {}),
                        " \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...  "
                    ]
                })
            ]
        })
    });
}





const $28f924a6e30333b7$var$root = (0, $aRPiL.createRoot)(document.getElementById("booking-module-widjet-root"));
$28f924a6e30333b7$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $8531facd38432db1$export$511301e5919f9ef5), {}));


//# sourceMappingURL=index.d7f318be.js.map
